module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Usb-storage-d2d122ba699fafe053ded6d6b424238d.svg";